import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { showJobRangeDetails } from '../../actions/jobRangeDetails';
import { showSlideout } from '../../../../Slideout/SlideoutReducer';
import { getMarketReferenceField } from '../../Utils/Utils';
import { applyRounding, parseNumCheckNull } from '../../../../lib/formatters';
import { doesJobContainSpecificRangeDetails } from '@payscale/ps-isomorphic/dist/JobRanges/Utils';
import { SLIDEOUTS } from '../../../../Slideout/Slideouts';
import AdvancedTable from '../../../../AdvancedTable/AdvancedTable';
import AdvancedCell from '../../../../AdvancedTable/AdvancedCell';
import CustomJobIndicator from './CustomJobIndicator';
import JobListViewEmptyState from '../../JobListViewEmptyState/JobListViewEmptyState';
import Placeholder from '../../../../Placeholder/Placeholder';
import SubLabelList from '../../../../SubLabelList/SubLabelList';
import './ModelJobsList.scss';

const columnHeaders = [
  {
    Header: 'Job',
    width: 200
  },
  {
    Header: 'Mkt Ref Pnt',
    width: 40,
    centerAlign: true
  },
  {
    Header: 'Current Mid',
    width: 40,
    centerAlign: true
  },
  {
    Header: 'Proposed Mid',
    width: 40,
    centerAlign: true
  }
];

const propTypes = {
  modelDetails: PropTypes.object,
  showJobRangeDetails: PropTypes.func,
  showSlideout: PropTypes.func
};

class ModelJobsList extends Component {
  constructor(props) {
    super(props);

    this.getMarketReferenceColumn = this.getMarketReferenceColumn.bind(this);
    this.getTableRow = this.getTableRow.bind(this);
    this.getPlaceholder = this.getPlaceholder.bind(this);
    this.showJobRangeDetails = this.showJobRangeDetails.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.modelDetails.filteredModelJobs !== this.props.modelDetails.filteredModelJobs) {
      this.forceUpdate();
    }
  }

  getTableRow(job) {
    const { org_job_code, org_job_code_key, status, job_family } = job.original;
    const { modelDetails, preferences, replacementTokens, useJobCodeKey } = this.props;
    const jobCodeKeyText = replacementTokens?.find(label => label.token === 'job_code_key_text')?.value;
    const marketReferenceColumn = this.getMarketReferenceColumn(job.original);
    const hasGlobalOverride = doesJobContainSpecificRangeDetails(job.original);
    let subLabels = [{ label: 'Job Code', text: org_job_code, id: 'job__sublabel-jobCode' }];
    const payType = modelDetails?.jobRangeModel ? modelDetails?.jobRangeModel?.payType : undefined;
    if (useJobCodeKey)
      subLabels.push({ label: jobCodeKeyText, text: org_job_code_key !== ' ' ? org_job_code_key : 'Not Set', id: 'job__sublabel-jobCodeKey' });
    subLabels.push({ label: 'Job Family', text: job_family ? job_family : 'Not Set', id: 'job__sublabel-family' });
    subLabels.push({ label: 'Status', text: status, id: 'job__sublabel-status' });

    return (
      <React.Fragment>
        <AdvancedCell
          className={classnames({
            proposed__job: status === 'Proposed',
            current__job: status === 'Current'
          })}
          getCellProps={job.cells[0].getCellProps}
        >
          <h5 className="jbr__model-job-title">{job.original.org_job_title}</h5>
          <div className="job__sublabel-container">
            <SubLabelList subLabels={subLabels} />
            {hasGlobalOverride && <CustomJobIndicator job={job.original} />}
          </div>
        </AdvancedCell>
        <AdvancedCell className="center-align" getCellProps={job.cells[1].getCellProps}>
          {parseNumCheckNull(applyRounding(job.original[marketReferenceColumn], 'monetary', preferences, payType))}
        </AdvancedCell>
        <AdvancedCell className="center-align" getCellProps={job.cells[2].getCellProps}>
          {parseNumCheckNull(applyRounding(job.original.salary_midpoint, 'monetary', preferences, payType))}
        </AdvancedCell>
        <AdvancedCell className="center-align" getCellProps={job.cells[3].getCellProps}>
          {parseNumCheckNull(applyRounding(job.original.proposed_midpoint, 'monetary', preferences, payType))}
        </AdvancedCell>
      </React.Fragment>
    );
  }

  getMarketReferenceColumn(job) {
    const { modelDetails } = this.props;
    return getMarketReferenceField(modelDetails.jobRangeModel, job);
  }

  getPlaceholder() {
    const { modelJobsSearchTerm } = this.props.modelDetails;

    return (
      <Placeholder>
        <div className="placeholder__text-primary">
          No search results for
          <span className="placeholder__search-text">{`"${modelJobsSearchTerm}"`}</span>
        </div>
        <div className="placeholder__text-secondary">Please try different keywords</div>
      </Placeholder>
    );
  }

  showJobRangeDetails(job) {
    const { showJobRangeDetails } = this.props;
    return showJobRangeDetails(job.original);
  }

  render() {
    const { modelDetails, showSlideout } = this.props;
    const { modelJobs } = modelDetails;
    if (!modelJobs.length)
      return <JobListViewEmptyState addJobsToModelClick={() => showSlideout(SLIDEOUTS.JOB_RANGES_SLIDEOUT)} />;

    return (
      <AdvancedTable
        allowSorting={false}
        className="model__jobs-list"
        columnHeaders={columnHeaders}
        customEmptyComponent={this.getPlaceholder()}
        getDataRow={this.getTableRow}
        headerClassName="model__jobs-list-header"
        onRowClick={this.showJobRangeDetails}
        rowData={modelDetails.filteredModelJobs}
        staticTable={true}
      />
    );
  }
}

ModelJobsList.propTypes = propTypes;

const connectState = ({ jobRanges: { modelDetails, jobRangeDetails, addJobsList }, session }) => ({
  modelDetails,
  preferences: session?.user?.preferences,
  selectedJobs: addJobsList.selectedJobs
});
const actions = {
  showJobRangeDetails,
  showSlideout
};
export default connect(connectState, actions)(ModelJobsList);
